export default "__VITE_ASSET__CPDkj2lN__"